import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { demoCenterPath } from '../../data/demoCenter';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-1190" data-mp="294arynz6wti2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-1191" data-mp="2wu4y6mp07jtc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-1192" data-mp="31thnrf79f4zm">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-1193" data-mp="2s2d9khpero5u">
            Connected knowledge. Capable people. Smarter action.
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-1194" data-mp="3klafl6alek5r">
            SyNeural develops systems that help people and institutions connect knowledge, strengthen judgment and
            turn evidence into practical action.
          </p>
          <p className="mt-5 text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-1195" data-mp="xnsrc9f7wgdr">
            SKP governs the knowledge. HCF structures assessment and development. Noetivra brings the relevant
            resources into workspaces designed for each field.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-1196" data-mp="12mm7k9lw2lhm">
            <a href="/solutions" className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-1197" data-mp="12mdt4da4b84b">
              Explore Our Solutions
              <ArrowRight size={18} aria-hidden="true" data-id="element-1198" data-mp="3ie1mxztu4kiw" />
            </a>
            <a href={demoCenterPath} className="inline-flex items-center justify-center gap-2 border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1199" data-mp="3ed8079s4pbrl">
              Explore Noetivra Demos
              <ArrowRight size={18} aria-hidden="true" data-id="element-1200" data-mp="1r8wz52rrapmo" />
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-1201" data-mp="1wadz8w2f2827">
          <IntelligenceDiagram data-id="element-1202" data-mp="20ao76e9rr8jp" />
        </div>
      </div>
    </section>;
}